"use client";
import WrapCards from "@/components/cardsWrap";
import { CYBER_SECURITY_OPTIONS } from "./constants";

const Options = () => {
  return (
    <WrapCards
      list={CYBER_SECURITY_OPTIONS}
      Width={{
        base: "100%",
        sm: "40vw",
        md: "26vw",
        lg: "20vw",
        "2xl": "19vw",
      }}
      maxWidth={"360px"}
      spacing={{ base: 8, sm: "4vw", md: "3vw", lg: "2vw" }}
      hoverEffect={true}
    />
  );
};

export default Options;
